export const priceStringToNumber = (value: string) => {
  // Eliminar el carácter '$' y '.' del string
  const formatValue = value?.replace(/[$.]/g, '')

  // Convertir el string resultante a un número
  const valueToNumber = parseFloat(formatValue)

  return valueToNumber
}
